import { FC, useEffect, useState } from 'react';
import { Box, Flex, Tab, TabList, Tabs, Text } from '@chakra-ui/react';
import { CbTableSearchbar } from '../CbTable/CbTableSearchbar';
import { CbTableDropdownFilter } from '../CbTable/CbTableDropdownFilter';
import { Team } from '../../../types';
export interface CbParticipantSearchHeaderProps {
  teams: Team[];
  onPlayerSearchChange: (query: string) => void;
  handleTeamFilter: (filter: string) => void;
  hideTabs?: boolean;
}
export const CbParticipantSearchHeader: FC<CbParticipantSearchHeaderProps> = ({
  teams,
  handleTeamFilter,
  onPlayerSearchChange,
  hideTabs = false
}) => {
  const [teamNames, setteamNames] = useState<string[]>([]);
  const [tabIndex, settabIndex] = useState(0);
  useEffect(() => {
    const teamNamesArray = teams.map(team => team?.name);
    setteamNames(teamNamesArray);
  }, [teams]);
  return <>
      <Tabs defaultIndex={0} data-sentry-element="Tabs" data-sentry-source-file="CbParticipantSearchHeader.tsx">
        <Flex data-sentry-element="Flex" data-sentry-source-file="CbParticipantSearchHeader.tsx">
          <Text fontSize={{
          md: '22px'
        }} fontFamily="codenext" color="text.primary" data-sentry-element="Text" data-sentry-source-file="CbParticipantSearchHeader.tsx">
            Select Learners
          </Text>
          {!hideTabs && <TabList marginLeft={20} border={'none'}>
              <Tab _focus={{
            borderLeft: 'none',
            borderRight: 'none'
          }} _active={{
            background: 'none'
          }} onClick={() => {
            settabIndex(0);
            handleTeamFilter('Clear');
          }}>
                By Name
              </Tab>
              <Tab _focus={{
            borderLeft: 'none',
            borderRight: 'none'
          }} _active={{
            background: 'none'
          }} onClick={() => settabIndex(1)}>
                By Team
              </Tab>
            </TabList>}
        </Flex>

        <Box marginTop={4} data-sentry-element="Box" data-sentry-source-file="CbParticipantSearchHeader.tsx">
          {tabIndex === 0 ? <CbTableSearchbar onTextFilterChange={onPlayerSearchChange} backgroundColor="none" borderColor="cloud.400" width={{
          md: '98%'
        }} /> : <CbTableDropdownFilter width="50%" dropdownFilters={['Clear', ...teamNames]} filter={'Teams'} handleChange={filter => handleTeamFilter(filter)} />}
        </Box>
      </Tabs>
    </>;
};